import React, { useState, useCallback } from 'react';
import Datepicker from 'components/actions/DatePicker';
import { useTranslation } from 'react-i18next';
import { getI18nValue } from 'utils/Utils';
import ConversationsChart from './ConversationsChart';

import UniqueUsersCard from './UniqueUsersCard';
import TopIntentsChart from './TopIntentsChart';
import EscalationRateCard from './EscalationRateCard';
import ChannelSelect from './ChannelSelect';
import LanguageSelect from './LanguageSelect';

function KPIDashboard() {
    const { t } = useTranslation();

    const [dateRanges, setDateRanges] = useState({
        startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
        endDate: new Date(),
        key: 'selection',
    });
    const [channel, setChannel] = useState('');
    const [language, setLanguage] = useState('');

    // Stable reference so MemoDatepicker never re-renders (setDateRanges is already
    // stable from useState, but useCallback makes the intent explicit).
    const handleDateChange = useCallback((newRanges) => setDateRanges(newRanges), []);

    return (
        <div className="col-span-full bg-white shadow-sm rounded-sm border border-gray-200">
            <div className="p-4 border-b border-gray-100">
                <div className="sm:flex sm:justify-between sm:items-center">
                    <div className="mb-4 sm:mb-0">
                        <header className="text-xl font-semibold text-gray-800">
                            {t(getI18nValue('analytics.kpi', 'title'))}
                        </header>
                        <p className="text-sm font-light">
                            {t(getI18nValue('analytics.kpi', 'description'))}
                        </p>
                    </div>
                    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2 mb-4">
                        <ChannelSelect value={channel} onChange={setChannel} />
                        <LanguageSelect value={language} onChange={setLanguage} />
                        <Datepicker callBack={handleDateChange} />
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-12 gap-4 p-4">
                <ConversationsChart dateRanges={dateRanges} channel={channel} language={language} />
                <div className="col-span-full md:col-span-6 xl:col-span-3">
                    <UniqueUsersCard dateRanges={dateRanges} channel={channel} language={language} />
                </div>
                <div className="col-span-full md:col-span-6 xl:col-span-3">
                    <EscalationRateCard dateRanges={dateRanges} channel={channel} language={language} />
                </div>
                <TopIntentsChart dateRanges={dateRanges} channel={channel} language={language} />
            </div>
        </div>
    );
}

export default KPIDashboard;
